'use client';

import { Heading } from '@petsmart-ui/sparky';

import { useProduct } from '@/entities/product';

export const Title = () => {
    const { product } = useProduct();

    return (
        <Heading tagName="h1" size="title" data-testid="test-pdp-title">
            {product?.name}
        </Heading>
    );
};
